import { render, staticRenderFns } from "./c_odeme.vue?vue&type=template&id=55515a8b"
import script from "./c_odeme.vue?vue&type=script&lang=js"
export * from "./c_odeme.vue?vue&type=script&lang=js"
import style0 from "./c_odeme.vue?vue&type=style&index=0&id=55515a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports